module.exports = [
	"I thrive in ambiguous roles and situations. I don’t mind not having total control in my environment.",
	"I have a knack for thinking holistically. I naturally consider multiple issues integratively.",
	"I tend to behave adaptively in different situations depending on the need, the audience, etc.",
	"I am very successful at building interpersonal relationships with people of widely varying types.",
	"Work/life balance for my organization is a priority that exists, not just in theory.",
	"I am a committed life-long learner. I continually seek information and have a natural curiosity that I indulge.",
	"I am looked to as a leader of change in my organization. I know how and want to help people transition from what was to what has to be.",
	"I am highly credible. When I say I will get something done, people know for certain that I will.",
	"I make it a point to let my employees know how their actions contribute to the organization’s vision, mission, and values.",
	"I often “see” organizational opportunities and options that others do not.",
	"I am known as someone who places the highest priority on behaving ethically and honestly.",
	"I understand and am able to tap into my people’s excitement.",
	"I am aware of my shortcomings and seek to surround myself with talented people who make up for these.",
	"My memory is superior to most people I know.",
	"I enjoy doing good work for the intrinsic value. I do not purposefully seek credit or praise.",
	"I make it a point to explore outside my area of expertise to solve problems.",
	"I make it a point to make my strategies tangible to my people. I take many opportunities to explain what the strategy means to the individual.",
	"I am very aware and attuned to others’ perceptions of me.",
	"I am able to understand different disciplines at a deep level better than most people I know.",
	"I have a knack for asking the right questions.",
	"I motivate my people by creating a higher order of aspiration (e.g., striving to beat themselves, striving to do well for the sake of a better world, etc.).",
	"I welcome input from others, regardless if it aligns with my way of thinking.",
	"I am highly organized. I am able to manage multiple strategies at the same time.",
	"I have a balance between thinking and acting.",
	"I always seek to apply the knowledge that I gain."
];


//////////////////
// WEBPACK FOOTER
// ./src/questions.json
// module id = 277
// module chunks = 0